import React from "react";
import {
  Grid,
  Paper,
  Typography,
  Box,
  Card,
  CardContent,
} from "@material-ui/core";
import Skeleton from "@material-ui/lab/Skeleton";

const MSSPFulfillment = ({ classes, paperTitle, currencySymbol }) => {
  return (
    <Grid item xs={12}>
      <Paper className={classes.paper}>
        <Box display="flex" flexDirection="column" alignItems="center" mb={3}>
          <Typography variant="h5" className={classes.title}>
            MSSP Fulfillment – Cumulative ACV ({currencySymbol}M)
          </Typography>
          <span className={classes.updateFrequency}>{"Live Data"}</span>
        </Box>

        <Grid container spacing={3}>
          <Grid item xs={12}>
            <Card className={classes.chartCard}>
              <CardContent>
                <Box
                  className={classes.chartContainer}
                  style={{ minHeight: 350 }}
                >
                  <Skeleton
                    variant="rect"
                    animation="wave"
                    height={300}
                    width="100%"
                  />
                </Box>
              </CardContent>
            </Card>
          </Grid>
        </Grid>
      </Paper>
    </Grid>
  );
};

export default MSSPFulfillment;
